import { gql, TypedDocumentNode } from "@apollo/client";

import {
  FraudConfListsQuery,
  FraudConfListsQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { confListFragment } from "src/graphql/anti-fraud/fragments/ConfListFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToConfList } from "src/mappers/confList.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getListFraudTypeQuery = gql`
  query fraudConfLists {
    fraudConfList(code: "FraudType") {
      ...ConfListFragment
    }
  }

  ${confListFragment}
` as TypedDocumentNode<FraudConfListsQuery, FraudConfListsQueryVariables>;

export const useGetListFraudTypeQuery = ({ onCompleted, onError, skip = false }) => {
  return useFetchQuery(getListFraudTypeQuery, {
    queryOptions: { onCompleted, onError, skip },
    toData: (data) => (data?.fraudConfList ? mapToConfList(data.fraudConfList) : null),
    isEmpty: (data) => isEmpty(data?.fraudConfList.elements),
    uiErrors: {
      fetchError: "FETCH-LIST-TYPES-ERROR",
      emptyError: "EMPTY-LIST-TYPES-ERROR",
    },
  });
};
